import styled from "styled-components";

export const Flex = styled.div`
display:flex;
align-items:center;
flex-wrap: wrap;
justify-content: center;
gap: 15px;
`